import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ showUpgrade = false, onManageBilling = null }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const getTierBadgeClass = (tier) => {
        if (!tier) return 'bg-secondary';
        switch (tier.toLowerCase()) {
            case 'admin':
                return 'bg-danger text-white';
            case 'enterprise':
                return 'bg-warning text-dark';
            case 'basic':
                return 'bg-primary';
            default:
                return 'bg-secondary';
        }
    };

    const tier = user?.tier || 'free';
    const isAdmin = user?.is_admin || false;

    return (
        <nav className="navbar navbar-dark bg-black">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">frwd labs</a>
                <div className="d-flex align-items-center gap-3">
                    {isAdmin ? (
                        <span className="badge bg-danger">ADMIN</span>
                    ) : (
                        <span className={`badge ${getTierBadgeClass(tier)}`}>
                            {tier.toUpperCase()}
                        </span>
                    )}
                    <span className="small text-secondary">{user?.email}</span>

                    {showUpgrade && tier === 'free' && !isAdmin && (
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={() => navigate('/select-plan')}
                        >
                            Upgrade
                        </button>
                    )}

                    {onManageBilling && (tier === 'basic' || tier === 'enterprise') && !isAdmin && (
                        <button
                            className="btn btn-outline-light btn-sm"
                            onClick={onManageBilling}
                        >
                            Manage Billing
                        </button>
                    )}

                    <button
                        className="btn btn-outline-light btn-sm"
                        onClick={handleLogout}
                    >
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;

